import { DATE_SORT_FIELDS, safelyParseDate } from '@/utils/date';

const getSortableValue = (value, orderBy) => {
	if (value == null || value === '') {
		return null;
	}
	if (DATE_SORT_FIELDS.has(orderBy)) {
		const date = safelyParseDate(value);
		return date ? date.getTime() : null;
	}
	if (typeof value === 'string') {
		return value.toLowerCase();
	}
	if (typeof value === 'object' && 'label' in value) {
		return value.label;
	}
	return value;
};

const isEmptySortValue = (row, orderBy) => {
	const sortable = getSortableValue(row[orderBy], orderBy);
	return sortable == null;
};
/**
 * Compares two objects for sorting in descending order based on a specified property.
 *
 * @param {Object} a - The first object to compare.
 * @param {Object} b - The second object to compare.
 * @param {string} orderBy - The property name to be used for comparison.
 * @returns {number} - Returns -1, 0, or 1 as per the comparison logic for sorting.
 */
// export function descendingComparator(a, b, orderBy) {
// 	// Determine the value from objects 'a' and 'b' for comparison:
// 	// - If the property is a string, convert it to lowercase for case-insensitive comparison.
// 	// - If the property is an object and has a 'label' property, use the 'label' for comparison.
// 	// - Otherwise, use the property value as is.
export function descendingComparator(a, b, orderBy) {
	const aOrderBy = getSortableValue(a[orderBy], orderBy);
	const bOrderBy = getSortableValue(b[orderBy], orderBy);
	if (bOrderBy < aOrderBy) {
		return -1;
	}
	if (bOrderBy > aOrderBy) {
		return 1;
	}
	return 0;
}

export function getComparator(order, orderBy, nullAlwaysLast = false) {
	const compareWithNullsLast = (a, b, compare) => {
		if (nullAlwaysLast) {
			const aEmpty = isEmptySortValue(a, orderBy);
			const bEmpty = isEmptySortValue(b, orderBy);
			if (aEmpty && bEmpty) return 0;
			if (aEmpty) return 1;
			if (bEmpty) return -1;
		}
		return compare(a, b);
	};
	return order === 'desc'
		? (a, b) => compareWithNullsLast(a, b, () => descendingComparator(a, b, orderBy))
		: (a, b) => compareWithNullsLast(a, b, () => -descendingComparator(a, b, orderBy));
}

export function stableSort(array, comparator) {
	const stabilizedThis = array.map((el, index) => [el, index]);
	stabilizedThis.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	});
	return stabilizedThis.map((el) => el[0]);
}
